import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  selectUserActiveEmployerBusinessId,
  selectUserActiveEmployerInfo,
} from 'store/user/selectors.js/user.selectors';
import { updateShadowRecord } from '../services/updateShadowRecord.service';

export const updateShadowRecordAssignment = createAsyncThunk(
  'shadowData/updateShadowRecordAssignment',
  async ({ recordId, assignment, assignmentUnitAmount }, { getState }) => {
    const state = getState();
    const activeEmployerBusinessId = selectUserActiveEmployerBusinessId(state);
    const activeEmployerInfo = selectUserActiveEmployerInfo(state);

    if (!activeEmployerBusinessId || !recordId) {
      return null;
    }

    const shadowRecordId = `${recordId}_${activeEmployerBusinessId}`;
    const updatedShadowRecord = await updateShadowRecord(
      shadowRecordId,
      { assignment, assignmentUnitAmount },
      activeEmployerInfo
    );

    return updatedShadowRecord;
  }
);
